import { Box, Card, Typography } from "@mui/material";
import React from "react";
export function VeganKofta() {
  return (
    <Card sx={{ backgroundColor: "#bbbbbb" }}>
      <Typography variant="h1">Vegan Kofta</Typography>

      <Typography>
        <Typography variant="h3">Ingredients</Typography>
        <b>Kofta</b>
        <br></br>
        16 Ounces Vegan ground beef <br></br>
        1/2 a Red onion, grated<br></br>4 Cloves Garlic, grated<br></br>1
        Tablespoon Fresh dill, chopped<br></br>1 Tablespoon Fresh mint, chopped
        <br></br>1 teaspoon Cumin<br></br>1 teaspoon Oregano<br></br>
        1/2 teaspoon Cinnamon<br></br>
        1/2 teaspoon Salt<br></br>
        1/4 teaspoon Black pepper<br></br>6 Wooden skewers, soaked<br></br>
        <br></br>
        <b>Tzatziki Sauce</b>
        <br></br>1 Cup Vegan Greek style yogurt<br></br>1 Cup Grated cucumber
        <br></br>1 Tablespoons Fresh dill<br></br>1 Tablespoons Fresh Mint
        <br></br>2 Cloves Garlic, grated<br></br>1 Tablespoon Lemon juice
        <br></br>
        1/2 teaspoon Lemon zest<br></br>
        1/2 teaspoon Salt<br></br>
        1/4 teaspoon Black pepper<br></br>1 teaspoon Za'atar seasoning(optional)
        <br></br>
        <br></br>
        <b>For Serving</b>
        <br></br>
        Flatbread<br></br>
        Lettuce<br></br>
        Tomato<br></br>
        Hummus<br></br>
      </Typography>

      <Typography>
        Preheat the oven to 400 degrees(F).<br></br>
        In a large mixing bowl, add the vegan ground beef, grated onion and
        garlic, the fresh herbs and all the spices.<br></br>
        Mix everything together, so it is completely combined.<br></br>
        <br></br>
        Divide the kofta mixture into 6 equal portions.<br></br>
        Take one portion and wrap it around one of the skewers that you soaked.
        <br></br>
        Pressing around evenly so that is a cylinder up the skewer.<br></br>
        Place on a baking sheet lined with parchment paper or sprayed with
        non-stick spray.<br></br>
        <br></br>
        Repeat with the remaining kofta mixture, placing all the skewers on the
        sheet pan.<br></br>
        Bake for 10-12 minutes or until they are nice and firm.<br></br>
        <br></br>
        While the kofta bakes, make the tzatziki. Add all the tzatziki
        ingredients to a medium sized mixing bowl and whisk to combine. Set in
        the fridge until ready to use.<br></br>
        Once the kofta has baked, remove from the oven and grill either on a
        grill pan or a grill for 1-2 minutes on each side, just to brown up. Or
        you can serve them as is, if you don't have a grill or grill pan.
        <br></br>
        Serve immediately with the tzatziki sauce, flatbread and veggies if
        desired.<br></br>
      </Typography>
    </Card>
  );
}
